<template lang="pug">
.content-wrap
	.content-top
		.con
			.reset-wrapper
				img.animate__animated.animate__wobble.animate__repeat-3(src='/new/img/logo.png')
				h2 {{$t('ui.reset_password')}}
				form
					//- .mb-2
					//- 	input.form-control#accountname(type='text' :placeholder="$t('ui.username')" v-model.trim="$v.accountId.$model" @keyup.enter="updatePassword")
					//- validation(:value="$v.accountId" :name="$t('ui.username')" target="FORGOTPASSWORD")
					.input-group.flex-nowrap
						//- span.input-group-text.btns.s2#addon-wrapping +63
						input.form-control(type='text' :placeholder="$t('ui.phone_number')" v-model.trim="$v.phoneNumber.$model" @keyup.enter="updatePassword" @keypress="$helpers.onlyNumber" @paste.prevent)
						//- .mb-2.d-flex.justify-content-between
							.btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.prefix +63
							input.form-control(type='text' :placeholder="$t('ui.phone_number')" v-model.trim="$v.phoneNumber.$model" @keyup.enter="updatePassword" @keypress="$helpers.onlyNumber" @paste.prevent)
					validation(:value="$v.phoneNumber" :name="$t('ui.phone_number')" target="FORGOTPASSWORD")
			.modal-footer.s2
				.text-center
					//- button.btn-submit(type='button' @click="openChat") CONTACT LIVECHAT
					button.btn-submit(:class="{'pe-none': loading}" type='button' @click="updatePassword") {{$t('ui.submit')}}
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import validation from "@/library/_validation.vue"
export default {
  components: {
    validation
  },
  data() {
    return {
      accountId: "",
      phoneNumber: "",
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  validations: {
    // accountId: {
    //   required,
    // },
    phoneNumber:{
      required
    }
  },
  mounted(){
  },
  methods:{
    updatePassword(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let account_id = this.phoneNumber
        let contact_phone = this.phoneNumber
        this.loading = true
        this.$store
          .dispatch("user/forgotPassword", { account_id , contact_phone})
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.reset()
              this.$helpers.showDialog(
                this.$t("ui.success"),
                this.$t("message.forgot_password_success"),
                "success",
                this
              );
            } else {
              var vm = this;
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
              }     
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = response.success
            var vm = this;
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          });
      }
    },
    reset(){
      this.accountId = ""
      this.phoneNumber= ""
      this.$v.$reset()
    },
    openChat() {
      LiveChatWidget.call("maximize");
    },
  }
}
</script>